export default "__VITE_ASSET__64b80adb__"